import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React, { useCallback, useRef, useState } from 'react';
import { findDOMNode } from 'react-dom';
import I18n from 'I18n';
import UIFileInput from 'UIComponents/input/UIFileInput';
import UIDropZone from 'UIComponents/drop/UIDropZone';
import { stopEvent } from '../../../utils/events';
var DropzoneUseType;

(function (DropzoneUseType) {
  DropzoneUseType["default"] = "default";
  DropzoneUseType["hover"] = "hover";
  DropzoneUseType["success"] = "success";
  DropzoneUseType["error"] = "error";
})(DropzoneUseType || (DropzoneUseType = {}));

const AvatarDropZone = ({
  onChange
}) => {
  const [dropzoneUse, setDropzoneUse] = useState(DropzoneUseType.default);
  const [file, setFile] = useState();
  const [fileUploading, setFileUploading] = useState(false);
  const [error, setError] = useState();
  const fileInputRef = useRef();
  const onError = useCallback(errorText => {
    setError(errorText);
    setDropzoneUse(DropzoneUseType.error);
    setFile(null);
    onChange(null);
  }, [onChange]);
  const readFile = useCallback(newFile => {
    if (newFile.type.indexOf('image/') !== 0) {
      onError(I18n.text('connectDotCom.avatarUpload.onlyImages'));
      return;
    }

    const reader = new FileReader();
    setFileUploading(true);

    reader.onload = () => {
      setFile(newFile);
      setFileUploading(false);
      setError(null);
      setDropzoneUse(DropzoneUseType.success);
      onChange(reader.result);
    };

    reader.readAsDataURL(newFile);
  }, [onChange, onError]);
  const handleDropZoneClick = useCallback(e => {
    const inputNode = findDOMNode(fileInputRef.current);

    if (inputNode && !inputNode.contains(e.target)) {
      fileInputRef.current.handleClick();
    }
  }, []);
  const handleFileChange = useCallback(e => {
    if (e.target.value === undefined) {
      return;
    }

    readFile(e.target.value);
  }, [readFile]);
  const handleDrop = useCallback(e => {
    stopEvent(e);

    if (e.dataTransfer.files.length !== 1) {
      onError(I18n.text('connectDotCom.avatarUpload.oneFileOnly'));
      return;
    }

    readFile(e.dataTransfer.files[0]);
  }, [onError, readFile]);
  const handleDragOver = useCallback(e => {
    stopEvent(e);
    setDropzoneUse(DropzoneUseType.hover);
  }, []);
  const handleDragExit = useCallback(e => {
    stopEvent(e);
    setDropzoneUse(DropzoneUseType.default);
  }, []);

  const FileInput = () => {
    return /*#__PURE__*/_jsx(UIFileInput, {
      "aria-label": I18n.text('connectDotCom.avatarUpload.uploadAvatarButton'),
      "data-test-id": "avatar-file-input",
      ref: fileInputRef // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      accept: ['image/*'],
      onChange: handleFileChange,
      use: "tertiary-light",
      value: file,
      disabled: fileUploading
    });
  };

  if (error || !file) {
    return /*#__PURE__*/_jsxs(UIDropZone, {
      "data-test-id": "avatar-drop-zone",
      iconName: "insertImage",
      size: "large",
      use: dropzoneUse,
      onDrag: stopEvent,
      onDragStart: stopEvent,
      onDragEnd: handleDragExit,
      onDragOver: handleDragOver,
      onDragEnter: handleDragOver,
      onDragLeave: handleDragExit,
      onDrop: handleDrop,
      onClick: handleDropZoneClick,
      children: [error ? /*#__PURE__*/_jsx("div", {
        children: error
      }) : null, /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FileInput, {})
      })]
    });
  }

  return /*#__PURE__*/_jsx(FileInput, {});
};

AvatarDropZone.propTypes = {
  onChange: PropTypes.func.isRequired
};
export default AvatarDropZone;